import React from 'react';
import styles from './CTAButton.module.scss';
import { useRouter } from 'next/router';
import { cx } from '@emotion/css';

type Props = {
  title: string;
  serviceName: string;
};
export const CTAButton = ({ title, serviceName }: Props) => {
  const router = useRouter();
  const params = new URLSearchParams({ serviceName });

  const gotoBookingFlow = () => {
    router.push(`/booking-flow?${params.toString()}`);
  };

  return (
    <div className={cx(styles.root, styles.cta_container)}>
      <a
        role="button"
        onClick={gotoBookingFlow}
        className={styles.btn_accent}
        style={{ width: 130, marginLeft: 10 }}>
        {title}
      </a>
    </div>
  );
};
